import { GroupKey } from "@common/types/todo";
import type { HighlightableId } from "@web/src/app/use-cases/todo-highlight";
import { withCenter } from "@web/src/app/utils/rect";
import type HighlightStore from "@web/src/store/highlight-store";
import { TodoHighlightableObject } from "@web/src/store/highlight-store";

export function findTodoHighlightable(
  todoId: string,
  highlightStore: HighlightStore,
  refPoint: DOMRect | undefined
): HighlightableId | null {
  const todoEntries = [...highlightStore.highlightObjMap.entries()].filter(
    ([highlightableId, highlightable]) => highlightable.kind === "todo" && highlightableId.includes(todoId)
  );

  // Find the entry that's the nearest to the center of the current highlightable
  let nearestDistance = Infinity;
  let nearestHighlightableId: string | undefined;
  const referenceCenter = withCenter(refPoint ?? new DOMRect());

  for (const [highlightableId, highlightable] of todoEntries) {
    const rect = highlightable.ref.current?.getBoundingClientRect();
    if (!rect) continue;
    const center = withCenter(rect);
    const distance = Math.sqrt(
      Math.pow(referenceCenter.centerX - center.centerX, 2) + Math.pow(referenceCenter.centerY - center.centerY, 2)
    );
    if (distance < nearestDistance) {
      nearestDistance = distance;
      nearestHighlightableId = highlightableId;
    }
  }

  if (!nearestHighlightableId) return null;

  return nearestHighlightableId;
}
